import React, { useState, useEffect } from 'react'
import {
  checkAuthorization,
  connect,
  mapStateToProps
} from '../../helpers/Common'

export default connect(mapStateToProps)(({ redux }) => {
  const [count, setCount] = useState(0)
  const [isOverLimit, setIsOverLimit] = useState(false)

  useEffect(() => {
    if (checkAuthorization(redux, 'claim.request.index')) {
      setCount(redux.notifications.claim_request)
    }
    if (redux.notifications.over_limit) {
      setIsOverLimit(redux.notifications.over_limit.includes('claim_request'))
    }
  }, [redux.notifications.claim_request, redux.notifications.over_limit])

  if (count <= 0) return <></>

  return (
    <label className='badge badge-warning position-static m-0 py-1' style={{ fontSize: '9px' }}>{count}{isOverLimit ? '+' : ''}</label>
  )
})
